export const MAX_GAMIFICATION_AVG_SPEED_KMH = 20;

export const toValidKmh = (value) => {
  const n = Number(value);
  return Number.isFinite(n) && n >= 0 ? n : NaN;
};

export const isAverageSpeedValidForGamification = (
  avgKmh,
  maxKmh = MAX_GAMIFICATION_AVG_SPEED_KMH
) => {
  const speed = toValidKmh(avgKmh);
  if (!Number.isFinite(speed)) return true;
  return speed <= maxKmh;
};
